import {
  AcademicCapIcon,
  ClipboardDocumentCheckIcon,
  MapPinIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline'
import React from 'react'

const SpecialEducationSection: React.FC = () => {
  const audiences = [
    {
      icon: AcademicCapIcon,
      title: 'For school special education teams',
      description:
        'Turn IEP-driven service needs into trackable requests with the student, school, service type, frequency, and documentation context needed to assign the right provider.',
    },
    {
      icon: UserGroupIcon,
      title: 'For NPAs and therapy companies',
      description:
        'Match students to qualified speech, occupational, physical, and behavioral therapy providers using availability, specialty, location, and service requirements.',
    },
    {
      icon: ClipboardDocumentCheckIcon,
      title: 'For coordinators managing compliance',
      description:
        'Keep provider outreach, accept or decline responses, review queues, and assignment decisions in one secure workflow with audit-friendly status history.',
    },
    {
      icon: MapPinIcon,
      title: 'For distributed provider networks',
      description:
        'Reduce manual sorting across campuses and regions by comparing provider fit, travel constraints, school assignments, and current capacity before outreach starts.',
    },
  ]

  return (
    <section
      className="section-padding bg-secondary-50"
      aria-labelledby="special-education-heading"
    >
      <div className="container-padding">
        <div className="max-w-4xl mb-12">
          <p className="text-sm font-semibold uppercase tracking-wide text-primary-600 mb-3">
            Special education provider matching
          </p>
          <h2
            id="special-education-heading"
            className="text-3xl sm:text-4xl font-bold text-secondary-900 mb-4"
          >
            Connect students who need therapy services with providers who can serve them
          </h2>
          <p className="text-xl text-secondary-600">
            TherapyLink is built for the operational work behind special education therapy services:
            receiving school requests, evaluating provider fit, coordinating outreach, and keeping
            every student assignment visible from referral through service start.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {audiences.map(audience => (
            <div
              key={audience.title}
              className="bg-white border border-secondary-200 rounded-lg p-6"
            >
              <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mb-5">
                <audience.icon className="w-6 h-6 text-primary-600" aria-hidden="true" />
              </div>
              <h3 className="text-xl font-semibold text-secondary-900 mb-3">{audience.title}</h3>
              <p className="text-secondary-600 leading-relaxed">{audience.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default SpecialEducationSection
